export default function QuelsOutils() {
  return (
    <main className="max-w-3xl mx-auto px-4 py-12">
      <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight text-slate-900">Quels outils</h1>
      <div className="mt-6 space-y-4 text-slate-700 leading-relaxed">
        <h3 className="font-semibold">Une pédagogie et ses outils</h3>
        <p>Notre équipe a fait le choix de la Pédagogie Institutionnelle pour guider son action et sa praxis éducative.</p>
        <ul className="star-list">
          <li><strong>La loi</strong> comme cadre commun et garant de l'intégrité et de la liberté de chacun.</li>
          <li><strong>Le conseil d'école</strong> et autres lieux de parole: expression, décisions, résolution des conflits.</li>
          <li><strong>Projet pédagogique personnalisé</strong> (contrat) établi chaque trimestre.</li>
          <li><strong>Évaluation formatrice</strong> par les ceintures de niveaux.</li>
        </ul>
      </div>
    </main>
  );
}
